import React from 'react';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function NoOpNode(props: ContactFlowNodeProps) {
  return <BaseNode {...props} title='No Op' />;
}
